import { DuctedRepresentativeData } from './ducted-compatibility-types';

// Per-type lead row as the server delivers it on the page response
// (representativesByType).
export type DuctedRepresentativePayload = {
  combination?: Record<string, unknown> | null;
  rank?: number | null;
  productData?: Record<string, any>;
  accessoryData?: Record<string, any>;
  modelSpecs?: Record<string, Record<string, unknown>>;
};

// The slice's shape for one delivered row; an absent type behaves like a
// zero-row response (null combination, no rank, empty enrichment maps).
export const representativeDataFrom = (
  payload: DuctedRepresentativePayload | undefined
): DuctedRepresentativeData => ({
  combination: payload?.combination ?? null,
  rank: typeof payload?.rank === 'number' ? payload.rank : null,
  productData: payload?.productData ?? {},
  accessoryData: payload?.accessoryData ?? {},
  modelSpecs: payload?.modelSpecs ?? {}
});

// Every delivered type, normalized, keyed as delivered.
export const representativesDataFrom = (
  byType: Record<string, DuctedRepresentativePayload | undefined> | undefined
): Record<string, DuctedRepresentativeData> =>
  Object.fromEntries(
    Object.entries(byType ?? {}).map(([typeCode, payload]) => [
      typeCode,
      representativeDataFrom(payload)
    ])
  );
